export default __webpack_public_path__ + "static/media/ip-homepage.691bad90.PNG";